import React from 'react'
import { connect } from 'react-redux'
import { FormSpy } from 'react-final-form'
import { updateFormState } from './FinalFormDuck'

const FinalFormStateToReduxPropagator = ({formName}) => {
   return (
       <FormSpy subscription={{ valid: true }} onChange={(state,bar) => {
            if(formName){
                updateFormState(formName, state)
            }
       }}/>
       )
}
export default FinalFormStateToReduxPropagator